import { render } from "./GoodsPopup.vue?vue&type=template&id=1c8284be&scoped=true"
import script from "./GoodsPopup.vue?vue&type=script&lang=js"
export * from "./GoodsPopup.vue?vue&type=script&lang=js"

import "./GoodsPopup.vue?vue&type=style&index=0&id=1c8284be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8284be"]])

export default __exports__